/**
 * @desc 修改设备信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.TheNewManagementDomainParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/equipment/update',
    data,
  });
}

export function mock(
  data: defs.TheNewManagementDomainParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/equipment/update',
    data,
  });
}
